import { Applicant, ApplicantAddressType, ApplicationProps } from '../redux-store/types/api-types';
import {
  applicantStatusMasters,
  ApplicationSourceMaster,
  APPLICATION_LISTING_STATUS,
  APPLICATION_TYPE,
  CurrencyMaster,
  SALT,
  SALT2,
  SAVE_LATER_VALIDATION_CHECK,
  USER_ROLES,
  timeZoneFromServer,
  ONBOARDING_ID_TYPES_MASTER,
  ONBOARDING_INVESTOR,
  NON_INDIVIDUAL_ID_TYPES_MASTER,
  INDIVIDUAL_ID_TYPES_MASTER,
  ACCOUNT_TYPE_MASTER,
  // ENABLE_RTA_APPROVER,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  yesNoMaster,
  FLOW_TYPE_MASTER,
  AdditionalKYCAndFatcaDeclarationUpdateDate,
  taxResidencyDocumentTypeMaster,
  feeTypeMaster,
  FUND_FLOW_TYPE_MASTER,
  DistributorTypesForUserManageMent,
  _DistributorTypesForUserManageMent,
  KBOLT_XALT_MASTER,
  ESIGN_STATUS,
  bankType,
  BankAccountTypeForVenture,
  NRIBankAccountTypeMaster,
  BankAccountTypeMaster,
  InboundOverseasBankAccountTypeMaster,
  InboundDomesticBankAccountTypeMaster,
} from './constant';
import { ToWords } from 'to-words';
import { individualPanRegex, nonIndividualPanRegex, numberRegex } from './regex';
import _ from 'lodash';
import AdapterMoment from '@mui/lab/AdapterMoment';
import momentTimezone from 'moment-timezone';
import { mdmsCountriesList } from '../redux-store/types/mdms';
import en from '../lang/en-us';
import * as countryCodes from 'country-codes-list';
import { ONBOARDING_METHODS } from '../components/onboarding/onboardingMethod';

export const maskMobileNumber = (mobileNumber: string): string => {
  if (!mobileNumber) {
    return '';
  }
  return (
    mobileNumber.slice(0, 2) +
    mobileNumber.slice(2, mobileNumber.length - 2).replace(/\d/g, '*') +
    mobileNumber.slice(mobileNumber.length - 2)
  );
};

export const getApplicantName = (index: number, isNomineeOrBank?: boolean): string => {
  if (index === 1) {
    return isNomineeOrBank ? 'First' : 'First/Sole';
  } else if (index === 2) {
    return 'Second';
  } else {
    return 'Third';
  }
};

export const minDateForContributor = (): Date => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 18);
  return date;
};

export const getFirstHolderName = (applicants: Partial<Applicant>[]): string => {
  return (
    applicants.find((applicant) => ['firstapplicant', '1'].includes(applicant.applicant_type || ''))
      ?.name || 'N/A'
  );
};

export const getApplicantType = (applicantType: string | undefined): string => {
  if (applicantType) {
    if (['firstapplicant', '1'].includes(applicantType)) {
      return '1';
    } else if (['secondapplicant', '2'].includes(applicantType)) {
      return '2';
    } else {
      return '3';
    }
  }
  return '';
};

export function toExactSubstr(str: string): string {
  const a = str.split('.');
  if (a.length == 2) {
    return a[0].concat('.', a[1].substr(0, 2));
  }
  return str;
}
export const formatCurrency = (value?: number | null, currencyType = 'INR'): string => {
  const formats = currencyType === 'USD' ? ['K', 'M', 'B'] : ['K', 'L', 'Cr'];
  let amount: any = Number(value);

  formats.some((key, i) => {
    const size = Math.pow(
      10,
      currencyType === 'INR'
        ? i === 0
          ? 3 // Thousands
          : 5 + (i - 1) * 2 // Lakhs and Crores
        : (i + 1) * 3
    ); // Thousands, Millions, Billions for USD

    if (size <= amount) {
      amount = (amount / size).toFixed(1); // One decimal point for precision
      if (parseFloat(amount) >= 100 && i < formats.length - 1) {
        amount = (parseFloat(amount) / 10).toFixed(1); // Scale down to one or two digits
        amount += ' ' + formats[i + 1];
      } else {
        amount += ' ' + formats[i];
      }
      return true;
    }
    return false;
  });

  return amount;
};

export const EIGHTEEN_YEARS_IN_MILLISECONDS = 18 * 31556926 * 1000; //  18 * no of seconds in a Year * 1000

export const isMinor = (dateOfBirth = ''): boolean => {
  return new Date().getTime() - new Date(dateOfBirth).getTime() < EIGHTEEN_YEARS_IN_MILLISECONDS;
};

export const isMajor = (dateOfBirth = ''): boolean => {
  return new Date().getTime() - new Date(dateOfBirth).getTime() > EIGHTEEN_YEARS_IN_MILLISECONDS;
};

// eslint-disable-next-line @typescript-eslint/no-var-requires
// const countryCodes = require('country-codes-list');
export const getCountryCodes = (): { label: string; key: string; countryCode: string }[] => {
  const countryCodesObject: { [key: string]: string } = countryCodes.customList(
    'countryCode',
    '{countryNameEn}: +{countryCallingCode}'
  );

  const modifiedCodes = Object.keys(countryCodesObject).map((cc) => ({
    label: countryCodesObject[cc],
    key: countryCodesObject[cc].split(':')[1].trim(),
    countryCode: cc,
  }));
  return modifiedCodes;
};

export const getAddressFields = (addressType: string): ApplicantAddressType => {
  return {
    address1: '',
    address2: '',
    address3: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
    permanentAddressSameAsCorresponding: false,
    address_type: addressType,
    isActive: true,
    fetchedFromKRA: null,
  };
};

export const getAddressData = (
  addressType: string,
  addresses: Partial<ApplicantAddressType>[] | undefined
): Partial<ApplicantAddressType> => {
  return (
    addresses?.find((address) => address.address_type === addressType) ||
    getAddressFields(addressType)
  );
};

export function getRelation(relationValue?: string | null): boolean {
  return ['Mother', 'Father', 'Daughter', 'Son', 'Spouse', 'Brother', 'Sister', ''].includes(
    relationValue || ''
  );
}

export const saveForLater = (
  role: string,
  id?: string,
  applicant1ReferenceId?: string | null
): string => {
  return role === USER_ROLES.INVESTOR
    ? `/investment-details/${applicant1ReferenceId}/application-details`
    : role === USER_ROLES.POAAPPROVER || role === USER_ROLES.AMCAPPROVER
    ? `/application-details/${id}`
    : '/applications';
};

export const maxAge = (dateOfBirth = ''): boolean => {
  const thisYear = new Date().getFullYear();
  return thisYear - new Date(dateOfBirth).getFullYear() > 125;
};

export function currencyConversion(
  num?: string | number | null,
  currencyType?: string | null
): string | null {
  if (!num) return '';
  const toWords = new ToWords({
    localeCode: CurrencyMaster[currencyType || ''] === CurrencyMaster.inr ? 'en-IN' : 'en-US',
  });
  const words = toWords.convert(Number(num), { currency: true });
  return words;
}

export function checkIfApplicationIsNonIndividual({ applicationType }: ApplicationProps): boolean {
  return applicationType === APPLICATION_TYPE.NON_INDIVIDUAL;
}

// eslint-disable-next-line
export const preventSpecialCharacters = (e: any) => {
  if (
    !((e.ctrlKey || e.metaKey) && e.keyCode == 67) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 86) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 88) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 90) &&
    !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Enter'].includes(e.key) &&
    !numberRegex.test(e.key)
  ) {
    e.preventDefault();
  }
};
export function allowOnlyNumbers(e: any): void {
  if (['-', '+', 'e', 'E'].includes(e.key)) {
    e.preventDefault();
  }
}
export const permanentAddressSameAsCorresponding = (
  updatedCorrespondingAddress: Partial<ApplicantAddressType>,
  addressType: string,
  addresses: Partial<ApplicantAddressType>[] | undefined
): Partial<ApplicantAddressType> => {
  // eslint-disable-next-line
  const { address1, address2, address3, city, pincode, state, country, ...rest } =
    updatedCorrespondingAddress;
  return {
    ...getAddressData(addressType, addresses),
    address1: address1,
    address2: address2,
    address3: address3,
    city: city,
    pincode: pincode,
    state: state,
    country: country,
    address_type: addressType,
  };
};
export const _updatedAddresses = (
  updatedAddresses: {
    nationality?: string | null | undefined;
    status?: string | null | undefined;
    permanent?: Partial<ApplicantAddressType> | undefined;
    correspondence?: Partial<ApplicantAddressType> | undefined;
    overseas?: Partial<ApplicantAddressType> | undefined;
    [key: string]: string | Partial<ApplicantAddressType> | null | undefined;
  },
  applicant: Partial<Applicant>
): Partial<ApplicantAddressType>[] => {
  const { nationality, status, ...addressProps } = updatedAddresses;
  return Object.keys(addressProps)
    .map((addressType) => {
      // if (applicant.nationality?.toLowerCase() === 'indian' && addressType === 'overseas') {
      //   return {};
      // }
      if (
        addressType === 'permanent' &&
        addressProps['overseas']?.permanentAddressSameAsCorresponding
      ) {
        return permanentAddressSameAsCorresponding(
          addressProps['overseas'],
          addressType,
          applicant.addresses
        );
      }
      if (
        addressType === 'permanent' &&
        addressProps['correspondence']?.permanentAddressSameAsCorresponding &&
        !addressProps['overseas']
      ) {
        return permanentAddressSameAsCorresponding(
          addressProps['correspondence'],
          addressType,
          applicant.addresses
        );
      }
      if (
        Object.keys(addressProps).length === 1 &&
        addressProps['overseas']?.permanentAddressSameAsCorresponding
      ) {
        return [
          {
            ...permanentAddressSameAsCorresponding(
              addressProps['overseas'],
              'permanent',
              applicant.addresses
            ),
          },
          {
            ...getAddressData(addressType, applicant.addresses),
            ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
            address_type: addressType,
          },
        ];
      }
      if (
        Object.keys(addressProps).length === 1 &&
        addressProps['correspondence']?.permanentAddressSameAsCorresponding
      ) {
        return [
          {
            ...permanentAddressSameAsCorresponding(
              addressProps['correspondence'],
              'permanent',
              applicant.addresses
            ),
          },
          {
            ...getAddressData(addressType, applicant.addresses),
            ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
            address_type: addressType,
          },
        ];
      }
      return {
        ...getAddressData(addressType, applicant.addresses),
        ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
        address_type: addressType,
      };
    })
    .flat()
    .filter((address) => Object.keys(address).length);
};
export const applyRoleBasedStatus = (role: any): boolean => {
  return [
    USER_ROLES.RM,
    USER_ROLES.SUBDISTRIBUTOR,
    USER_ROLES.DISTRIBUTOR,
    USER_ROLES.AMCAPPROVER,
    USER_ROLES.AMC_ADMIN,
  ].includes(role);
};

export const checkKraBasedOnStatus = (status: any): boolean => {
  return ![
    APPLICATION_LISTING_STATUS.invitationexpired,
    APPLICATION_LISTING_STATUS.signed,
    APPLICATION_LISTING_STATUS.completed,
    APPLICATION_LISTING_STATUS.rejected,
  ].includes(APPLICATION_LISTING_STATUS[status]);
};

export const applicationComparison = (
  existingApplication: Partial<ApplicationProps> | null,
  updatedApplication: Partial<ApplicationProps>
): boolean => {
  return _.isEqual(existingApplication, updatedApplication);
};

export const sendApplication_Nri = (application?: ApplicationProps | null): boolean | undefined => {
  return application?.applicants.map((applicant) => applicant.status).includes('NRI');
};

export const checkForCorrespondenceAddress = (
  nationality: string | null | undefined,
  status: string | null | undefined,
  flowType: string | null | undefined
): boolean => {
  return (
    (['indian', 'india'].includes(nationality?.toLowerCase() || '') &&
      applicantStatusMasters[status as string] === applicantStatusMasters.Individual) ||
    !IsInvestorWithPAN(flowType || '')
  );
};

export const setUpFeeCalculations = (
  commitmentAmount: number,
  setupFeePercentage: number
): { feeAmount: number; feeGst: number; totalSetupFee: number } => {
  const setupFeeAmount = (Number(commitmentAmount) * Number(setupFeePercentage)) / 100;
  const GstForSetupFee = (setupFeeAmount * 18) / 100;
  return {
    feeAmount: Number(setupFeeAmount),
    feeGst: Number(GstForSetupFee),
    totalSetupFee: Number(setupFeeAmount + GstForSetupFee),
  };
};

export const checkAddressField = (data?: string) => {
  if (data) {
    if (data.includes(' ,')) {
      return data.split(' ,').join(',') + ' ';
    }
    return data.includes(',') ? data + ' ' : data + ', ';
  }
  return '';
};

export const getBankAddress = (
  address1: string | undefined,
  address2: string | undefined,
  address3: string | undefined
): string => {
  return `${address2 ? checkAddressField(address1) || '' : address1 || '' || ''}${
    address3 ? checkAddressField(address2) || '' : address2 || ''
  }${address3 || ''}`;
};

export function folioValidationCheck(applicationSource: string): boolean {
  return ApplicationSourceMaster[applicationSource] === ApplicationSourceMaster.migration;
}

export const numToAlpMonth = (numMonth: any, month: any) => {
  numMonth?.map((monthNum: any) => {
    if (monthNum === 1) {
      month.push('Jan');
    } else if (monthNum === 2) {
      month.push('Feb');
    } else if (monthNum === 3) {
      month.push('Mar');
    } else if (monthNum === 4) {
      month.push('Apr');
    } else if (monthNum === 5) {
      month.push('May');
    } else if (monthNum === 6) {
      month.push('Jun');
    } else if (monthNum === 7) {
      month.push('Jul');
    } else if (monthNum === 8) {
      month.push('Aug');
    } else if (monthNum === 9) {
      month.push('Sep');
    } else if (monthNum === 10) {
      month.push('Oct');
    } else if (monthNum === 11) {
      month.push('Nov');
    } else if (monthNum === 12) {
      month.push('Dec');
    }
  });
};

export const removeSingleQuote = (value: string | null | undefined): any => {
  if (value && value.includes("'")) return value.split("'").join('');
  else return value;
};

export function removeEqualOperator(value = ''): string {
  const lastTwoIndex = value.length - 2;
  let encodeString = value.slice(0, lastTwoIndex);
  const slicedStr = value.slice(lastTwoIndex, value.length);
  slicedStr.split('').forEach((char) => {
    if (char !== '=') {
      encodeString += char;
    }
  });
  return encodeString;
}

export function encodeBase64(value: string): string {
  const encodeValue = btoa(value);
  const encodeSubString = removeEqualOperator(encodeValue);
  const encodePayload = btoa(`${SALT}${encodeSubString}${SALT2}`);
  return encodePayload;
}

export function getNomineeRelation(relationValue?: string | null): boolean {
  return [
    'MOTHER',
    'FATHER',
    'DAUGHTER',
    'SON',
    'SPOUSE',
    'BROTHER',
    'SISTER',
    '',
    'Husband',
    'Wife',
    'Cousin',
    'Father-in-law',
    'Sister-in-law',
    'Brother-in-law',
    'Mother-in-law',
    'Grandson',
  ].includes(relationValue || '');
}
export function applicationDownloadStatusCheck(status: string): boolean {
  return APPLICATION_LISTING_STATUS[status] !== APPLICATION_LISTING_STATUS.completed;
}

export function isMigrationAndTinDocument(documentType: string): boolean {
  return ['migration_document', 'tinProof', 'guardianTinProof', 'nomineeTinProof'].includes(
    documentType
  );
}

export const isDateSame = (date1: Date | string, date2: Date | string): boolean => {
  const { moment } = new AdapterMoment({ instance: momentTimezone });
  moment.tz.setDefault(timeZoneFromServer);
  momentTimezone.tz.setDefault(timeZoneFromServer);
  return (
    moment(date1).get('D') === moment(date2).get('D') &&
    moment(date1).get('M') === moment(date2).get('M') &&
    moment(date1).get('y') === moment(date2).get('y')
  );
};

export const nomineeRelationForAgeMajor = (nomineeRelationship: string): boolean => {
  return ['MOTHER', 'FATHER', 'SPOUSE'].includes(nomineeRelationship);
};

export const isIdTypeOutOfList = (idType: string): boolean => {
  return ONBOARDING_ID_TYPES_MASTER[idType] === ONBOARDING_ID_TYPES_MASTER.others;
};

export const checkRelationshipWithPep = (politicallyExposedPersonStatus: string): boolean => {
  return ['I am PEP', 'I am Related to PEP'].includes(politicallyExposedPersonStatus);
};

export const getRelationshipWithPepLabel = (politicallyExposedPersonStatus: string): string => {
  return (
    { 'I am PEP': 'Designation', 'I am Related to PEP': 'Relationship with PEP' }[
      politicallyExposedPersonStatus
    ] || ''
  );
};

const isCountryOrNationalityExist = (
  countryList: mdmsCountriesList[],
  countryOrNationality: string
): boolean => {
  return !!countryList?.find((country) =>
    [country?.name, country?.nationality].includes(countryOrNationality)
  );
};
export const eddDocumentCheck = (
  countryList: mdmsCountriesList[],
  applicant: Partial<Applicant>
): boolean => {
  const nationality = applicant?.nationality;
  const addressCountry = applicant.addresses?.reduce((obj, item) => {
    return { ...obj, [item.address_type as string]: item.country };
  }, {}) as { correspondence: string; permanent: string };
  return (
    isCountryOrNationalityExist(countryList, nationality as string) ||
    isCountryOrNationalityExist(countryList, addressCountry.permanent) ||
    isCountryOrNationalityExist(countryList, addressCountry.correspondence) ||
    checkRelationshipWithPep(applicant?.politicallyExposedPersonStatus || '')
  );
};

export const isOtherOccupation = (occupation: string): boolean => {
  return occupation?.toUpperCase() === 'OTHERS';
};

export function shouldValidateUponSaveLater(saveType: string): boolean {
  return (
    (saveType === 'save for later' && SAVE_LATER_VALIDATION_CHECK) || saveType !== 'save for later'
  );
}

export function getStep(currentStep: number, isSaveLater: boolean): number {
  return !SAVE_LATER_VALIDATION_CHECK && isSaveLater ? currentStep - 1 : currentStep;
}

export function getIdTypeDropDown(applicationType: string): string[] {
  return (
    ONBOARDING_INVESTOR[applicationType] !== ONBOARDING_INVESTOR.non_individual
      ? Object.keys(INDIVIDUAL_ID_TYPES_MASTER)
      : Object.keys(NON_INDIVIDUAL_ID_TYPES_MASTER)
  ).concat('others');
}

export const isOnboardingTypeMinor = (onBoardingType: string): boolean => {
  return ACCOUNT_TYPE_MASTER[onBoardingType] === ACCOUNT_TYPE_MASTER.minor;
};

export const isFatherMother = (guardianRelationship: string): boolean => {
  return ['MOTHER', 'FATHER'].includes(guardianRelationship);
};

export const futureDate = (inputDate = ''): boolean => {
  return new Date(inputDate) > new Date();
};

export const getFieldLabelForGuardian = (onBoardingType: string): string =>
  isOnboardingTypeMinor(onBoardingType) ? 'Guardian' : '';

export function isNonIndividualApplication(applicationType: string): boolean {
  return applicationType === APPLICATION_TYPE.NON_INDIVIDUAL;
}

export function isNaturalParent(naturalParent: string): boolean {
  return naturalParent.toLowerCase() === 'yes';
}

export const isIbancountry = (value: string, ibanCountries: mdmsCountriesList[]): boolean => {
  return Array.isArray(ibanCountries) && ibanCountries.some((c) => c.name === value);
};

export const MakerOrAdmin = (role: USER_ROLES): boolean =>
  [USER_ROLES.AMC_ADMIN, USER_ROLES.RM, USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(
    role
  );

// export const RTAApproverLoggedIn = (role: USER_ROLES): boolean => role === USER_ROLES.RTAAPPROVER;
export const AMCApproverLoggedIn = (role: USER_ROLES): boolean => role === USER_ROLES.AMCAPPROVER;
// export const RTAApproverEnableCheckForIndividual = (): boolean =>
//   ENABLE_RTA_APPROVER && AMC_APPROVER_CHECK_FOR_INDIVIDUAL;
// export const isRtaSendBackToMaker = (value?: string): boolean => value === 'maker';

export function checkIfApplicationIsNonIndividualPOA(application: ApplicationProps): boolean {
  if (application) {
    const { applicationType, hasPOA } = application;
    return applicationType === APPLICATION_TYPE.NON_INDIVIDUAL && hasPOA;
  } else return false;
}

export const displaySendBack = (application: ApplicationProps): string => {
  return application.applicationSentBack ? '(Send Back)' : '';
};

export const PlacementFeeApplicable = (isPlacementFeeApplicable: string): boolean =>
  yesNoMaster[isPlacementFeeApplicable] === yesNoMaster.yes;

export const handleDownload = async (fileUrl: string, fileName: string): Promise<void> => {
  try {
    const url = new URL(fileUrl, window.location.origin);

    const isSameOrigin = url.origin === window.location.origin;

    if (isSameOrigin) {
      // Same-origin: rename supported
      const response = await fetch(fileUrl);

      if (!response.ok) {
        throw new Error('Unable to download file');
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      link.remove();
      URL.revokeObjectURL(blobUrl);
    } else {
      // Cross-origin (e.g. S3): no fetch => no CORS issue
      const link = document.createElement('a');
      link.href = fileUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';

      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  } catch (error) {
    console.error('Download failed:', error);
    throw error;
  }
};
export const checkSupportLogin = (createdBy: string | number, id: string | number) => {
  return Number(createdBy) === Number(id);
};
export const checkSubDisDisable = (role: any, createdBy: string | number, id: string | number) => {
  return (
    [
      USER_ROLES.DISTRIBUTOR,
      USER_ROLES.INVESTOR,
      USER_ROLES.POAAPPROVER,
      USER_ROLES.AMCAPPROVER,
      USER_ROLES.AMC_ADMIN,
    ].includes(role) ||
    (USER_ROLES.SUBDISTRIBUTOR === role && !checkSupportLogin(Number(createdBy), Number(id)))
  );
};
export const IsInvestorWithPAN = (flowType: string): boolean =>
  FLOW_TYPE_MASTER[flowType] === FLOW_TYPE_MASTER.investor_with_pan;

export const futureAge = (dateOfBirth = ''): boolean => {
  return new Date(dateOfBirth) > new Date();
};

export const Maker = (role: USER_ROLES): boolean =>
  [USER_ROLES.RM, USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role);

export const statusRoleBased = (role: USER_ROLES, application: ApplicationProps | null): string => {
  return Maker(role) &&
    (application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL ||
      AMC_APPROVER_CHECK_FOR_INDIVIDUAL)
    ? 'draft'
    : application?.status || '';
};

export const checkNriPIO = (status: string, statusSubType: string): boolean => {
  return (
    applicantStatusMasters[status as string] === applicantStatusMasters.NRI &&
    applicantStatusMasters[statusSubType as string] === applicantStatusMasters.NRI_PIO
  );
};
export const checkForeignNational = (status: string, statusSubType?: string): boolean => {
  return applicantStatusMasters[status as string] === applicantStatusMasters.FOREIGN_NATIONAL;
};

export const checkNormalNri = (status: string, statusSubType?: string | null): boolean => {
  return applicantStatusMasters[status as string] === applicantStatusMasters.NRI && !statusSubType;
};

export const getCountryBasedOnStatus = (
  nationalitiesMdmsResponse: mdmsCountriesList[],
  status: string
): mdmsCountriesList[] => {
  return nationalitiesMdmsResponse.filter((ele) => {
    if (applicantStatusMasters[status] === applicantStatusMasters.NRI_PIO) {
      return !['PK', 'NP', 'AF', 'BD', 'CN', 'IQ', 'BT', 'LK'].includes(ele?.code || '');
    }
    if (applicantStatusMasters[status] === applicantStatusMasters.FOREIGN_NATIONAL) {
      return !['IN'].includes(ele?.code || '');
    }
    return ele;
  });
};

export const isValidPan = (pan: string): boolean =>
  [individualPanRegex, nonIndividualPanRegex].some((pattern) => pattern.test(pan));

export const checkValidationBasedOnDate = (
  date: string | number | Date,
  validationStartDate: string
): boolean => {
  if (!date) return false;
  const dateForCompare = date ? new Date(date) : new Date();
  const dateForApplyValidations = new Date(validationStartDate);
  return dateForCompare.getTime() >= dateForApplyValidations.getTime();
};

export const SourceWithinIndiaApproval = (date: string | number | Date) =>
  checkValidationBasedOnDate(date, AdditionalKYCAndFatcaDeclarationUpdateDate)
    ? `Derived from or originate from sources within India and written approval has been obtained from the Indian authorities for the investment (If applicable) and copy of which is enclosed for the records.`
    : `Derived from or originate from sources within India and written approval has been obtained from the Indian authorities for the investment, a copy of which is enclosed for the Company's records.`;

export const FatcaDeclaration = (date: string | number | Date) =>
  `I/We acknowledge and confirm that the information provided above is true and correct to the best of my knowledge and belief. In case any of the above specified information is found to be false or untrue or misleading or misrepresenting,I/am aware that I may liable for it. I/We hereby authorize you [Fund / Investment Manager] to disclose, share, rely, remit in any form, mode or manner, all/ any of the information provided by me to you including information to any Indian or foreign judicial authorities/ agencies, Financial Intelligence Unit-India (FIU-IND), the tax/ revenue authorities in India or outside India wherever it is legally required and other investigation agencies without any obligation of advising me of the same. Further , I authorize to share the given information to other SEBI Registered Intermediaries/or any regulated intermediaries registered with SEBI / RBI / IRDA / PFRDA to facilitate single submission/ update & for other relevant purposes. I also undertake to keep you informed in writing about any changes/ modification to the above information in future within 30 days and also undertake to provide any other additional information as may be required at your/ Fund's end or by domestic or overseas regulators/ tax authorities. I/We authorize Fund /AMC/ RTA to provide relevant information to upstream payors to enable withholding to occur and pay out any sums from my account or close or suspend my account(s) without any obligation of advising me of the same. I also confirm that I have read and understood the FATCA & CRS Terms and Conditions given ${
    !checkValidationBasedOnDate(date, AdditionalKYCAndFatcaDeclarationUpdateDate)
      ? 'below'
      : 'above'
  } and hereby accept the same.`;
export const FatcaDeclarationForOutbound = `I/We acknowledge and confirm that the information provided above is true and correct to the best of my/our knowledge and belief. In case any 
  of the above specified information is found to be false or untrue or misleading or misrepresenting, I/We am/are aware that I/We may liable for 
  it. I/We hereby authorize you [RTA/Administrator/Fund/FME/Other participating entities] to disclose, share, rely, remit in any form, mode or 
  manner, all / any of the information provided by me, including all changes, updates to such information as and when provided by me to / any 
  of the alternative investment fund, its sponsor, asset management company, trustees, their employees / RTAs (‘the Authorized Parties’) or any 
  Indian or foreign governmental or statutory or judicial authorities / agencies including but not limited to the Financial Intelligence Unit-India 
  (FIU-IND), the tax / revenue authorities in India or outside India wherever it is legally required and other investigation agencies without any 
  obligation of advising me/us of the same. Further, I/We authorize to share the given information to other IFSCA Registered Intermediaries /or 
  any regulated intermediaries registered with IFSCA to facilitate single submission / update & for other relevant purposes. I/We also undertake 
  to keep you informed in writing about any changes / modification to the above information in future within 30 days and also undertake to 
  provide any other additional information as may be required at your / Scheme’s end or by domestic or overseas regulators/ tax authorities. 
  I/We authorize Scheme/FME/RTA to provide relevant information to upstream payors to enable withholding to occur and pay out any sums 
  from my account or close or suspend my account(s) without any obligation of advising me of the same. We also confirm that we have read and 
  understood the FATCA & CRS Terms and Conditions given below and hereby accept the same.`;

export const checkNonResident = (status: string | undefined | null): boolean => {
  return (
    typeof status === 'string' &&
    applicantStatusMasters[status] !== applicantStatusMasters.Individual
  );
};

export const isNonResidentDeclaration = (
  taxResidencyDocumentType: string | undefined | null
): boolean => {
  return (
    typeof taxResidencyDocumentType === 'string' &&
    taxResidencyDocumentTypeMaster[taxResidencyDocumentType] ===
      taxResidencyDocumentTypeMaster.declaration_by_non_resident
  );
};

export const getFlowTypeNote = (
  flowType: string | null,
  funds: { schemeName: string; isInvestorWithPanApplicable: boolean }[] = []
): string | null => {
  if (!flowType) return null;
  const isOutbound = IsOutBoundFundFlow(flowType);
  const noteContent = funds
    .filter((fund) =>
      isOutbound ? !!fund.isInvestorWithPanApplicable : !fund.isInvestorWithPanApplicable
    )
    .map((fund) => fund.schemeName)
    .join(', ');
  return noteContent || null;
};

export const isFieldApplicable = (field: string | null | undefined): boolean => {
  if (!field) return false;
  return yesNoMaster[field] === yesNoMaster.yes;
};

export const isFieldTypeFixed = (field: string | null | undefined): boolean => {
  if (!field) return false;
  return feeTypeMaster[field] === feeTypeMaster.fixed;
};

export const isFieldTypeVariable = (field: string | null | undefined): boolean => {
  if (!field) return false;
  return feeTypeMaster[field] === feeTypeMaster.variable;
};
export const isNriAndPioStatus = (value: string): boolean => {
  return ['NRI', 'NRI_PIO'].includes(value);
};
export const minNetworthDate = (value: string): Date => {
  const date = new Date(value);
  date.setFullYear(date.getFullYear() - 1);
  return date;
};

export const getIsServiceRequired = (applicant: any): string[] => {
  const isServicesRequired: string[] = [];
  if (applicant.isMoneyLending === 'yes') isServicesRequired?.push('isMoneyLending');

  if (applicant.isGamingOrGambling === 'yes') isServicesRequired?.push('isGamingOrGambling');

  if (applicant.isForeignExchange === 'yes') isServicesRequired?.push('isForeignExchange');

  if (applicant.isNoneOfThese === 'yes') isServicesRequired?.push('isNoneOfThese');
  return isServicesRequired;
};

export const getServicesUpdate = (isServicesRequired: string[]) => {
  return {
    isMoneyLending: isServicesRequired?.includes('isMoneyLending') ? 'yes' : 'no',
    isGamingOrGambling: isServicesRequired?.includes('isGamingOrGambling') ? 'yes' : 'no',
    isForeignExchange: isServicesRequired?.includes('isForeignExchange') ? 'yes' : 'no',
    isNoneOfThese: isServicesRequired?.includes('isNoneOfThese') ? 'yes' : 'no',
  };
};

export const IsOutBoundFundFlow = (fundFlowType: string): boolean =>
  FUND_FLOW_TYPE_MASTER[fundFlowType] === FUND_FLOW_TYPE_MASTER.outbound;

export const IsCompanyDistributor = (role: string, type: string): boolean => {
  return (
    USER_ROLES.DISTRIBUTOR === role &&
    _DistributorTypesForUserManageMent[type] === _DistributorTypesForUserManageMent.company
  );
};

export const ifPushToXalt = (value: string): boolean => {
  return [KBOLT_XALT_MASTER.XALT, KBOLT_XALT_MASTER.KBOLT_XALT].includes(value);
};

export const isApplicationStatusComplete = (application: ApplicationProps): boolean => {
  return (
    APPLICATION_LISTING_STATUS[application?.status] === APPLICATION_LISTING_STATUS.completed &&
    !!Number(application.folio_no || application.xalt_folio_no || application.xorbit_folio_no)
  );
};

// Utility function to check if a bank is Overseas
export function isOverseasBank(investorBankType: string | undefined | null): boolean {
  if (!investorBankType) return false;
  return bankType[investorBankType] === bankType.Overseas;
}

export function isPaymentStepComplete(
  paymentCompleted: boolean,
  application?: ApplicationProps | null
): boolean {
  return paymentCompleted || isOverseasBank(application?.banks?.[0]?.investorBankType || '');
}

export const getActionLabel = (
  role: USER_ROLES,
  application: ApplicationProps | null | undefined,
  paymentCompleted: boolean
): string => {
  if (!application) return '';
  if (role === USER_ROLES.INVESTOR) {
    // Step 1: Payment not done → show "Make Payment"
    if (!isPaymentStepComplete(paymentCompleted, application)) {
      return 'Make Payment';
    }
    // Step 2: Payment done but e-sign not yet completed → show "e-Sign"
    const signStatus = application?.status || '';

    if (![ESIGN_STATUS.SIGNED, ESIGN_STATUS.EXPIRED, ESIGN_STATUS.COMPLETED].includes(signStatus)) {
      return 'e-Sign';
    }
    // Step 3: Payment + e-sign done → show "Done"
    return 'Done';
  }
  // Non-investor roles
  if (application?.hasPOA) {
    return 'Send to POA Approver';
  }
  if (
    sendApplication_Nri(application) ||
    (AMC_APPROVER_CHECK_FOR_INDIVIDUAL && applyRoleBasedStatus(role))
  ) {
    return 'Send to GIFT City Approver';
  }
  return 'Send to Investor';
};

export const scrollToBottom = () => {
  setTimeout(() => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth',
    });
  }, 0);
};

export const isIndividualResidentApplicant = (
  applicantStatus: string | null | undefined
): boolean => {
  if (!applicantStatus) return false;
  return applicantStatusMasters[applicantStatus] === applicantStatusMasters.Individual;
};

const NRI_STATUSES = ['NRI', 'NRI_PIO'];
export const isNRIStatus = (status?: string): boolean => !!status && NRI_STATUSES.includes(status);

/**
 * Returns applicable bank account types.
 * - Before toggle date: full list (old behaviour, unchanged).
 * - From toggle date: status-based split (Resident -> Current/Savings, NRI/PIO -> NRE/NRO/FCNR).
 */
export const getBankAccountTypeMaster = (
  applicationCreatedAt: string | number | Date | undefined,
  status: string | undefined,
  bankAccountTypeValidationDate: string | undefined,
  inboundBankAccountTypeValidationDate: string | undefined,
  flowType: string | null,
  bankLocationType?: string // e.g. 'Domestic' | 'Overseas'
): { [key: string]: string } => {
  if (!IsOutBoundFundFlow(flowType || '')) {
    const isInboundValidationApplicable = checkValidationBasedOnDate(
      applicationCreatedAt || '',
      inboundBankAccountTypeValidationDate || ''
    );

    if (!isInboundValidationApplicable) {
      return BankAccountTypeForVenture;
    }

    return bankLocationType === 'Overseas'
      ? InboundOverseasBankAccountTypeMaster
      : InboundDomesticBankAccountTypeMaster;
  }
  const isStatusBasedValidationApplicable = checkValidationBasedOnDate(
    applicationCreatedAt || '',
    bankAccountTypeValidationDate || ''
  );

  if (!isStatusBasedValidationApplicable) {
    return BankAccountTypeForVenture;
  }
  return bankLocationType === 'Overseas' ? NRIBankAccountTypeMaster : BankAccountTypeForVenture;
  // return isNRIStatus(status) ? NRIBankAccountTypeMaster : BankAccountTypeMaster;
};

// export const decodeState = (
//   stateValue = ''
// ): null | { digiLockerAmcCode: string; esignReferenceId: string; token: string; role: string } => {
//   if (!stateValue) return null;
//   return JSON.parse(atob(stateValue));
// };

export const decodeState = <T>(stateValue: string): T | null => {
  try {
    return JSON.parse(atob(stateValue)) as T;
  } catch {
    return null;
  }
};

export const isCKYCMethod = (onboardingMethod: string): boolean =>
  onboardingMethod === ONBOARDING_METHODS.CKYC;

// True when the scheme's journey/onboarding method is CVL KRA (KRA documents are applicable).
export const isCvlKraMethod = (onboardingMethod: string | null | undefined): boolean =>
  (onboardingMethod || '') === ONBOARDING_METHODS.CVL_KRA;

export const getFundSelectionNote = (flowType: string | null): string | null => {
  if (!flowType) return null;
  return IsOutBoundFundFlow(flowType) ? 'Applicable for RI, NRI' : 'Applicable for NRI only';
};

export const isTaxResidencyDeclarationScheme = (schemeId: string) => {
  return ['4', '3', '2'].includes(schemeId?.toString());
};

export const isUSTechFund = (schemeId: string) => {
  return ['3'].includes(schemeId?.toString());
};

// Scheme-specific rule handling for SchemeId 3 (Resident Individual simplifications).
export const isSchemeId3 = (schemeId: string | number | undefined | null) => {
  return String(schemeId ?? '') === '3';
};

// Outbound fund is identified purely by scheme id (SchemeId 2 and 3 are outbound funds).
const OUTBOUND_FUND_SCHEME_IDS = ['2', '3'];
export const isOutboundFund = (schemeId: string | number | undefined | null): boolean => {
  return OUTBOUND_FUND_SCHEME_IDS.includes(String(schemeId ?? ''));
};

// Combined check: applicant is a Resident Individual (RI) AND the scheme is SchemeId 3.
export const isRiSchemeId3 = (
  applicantStatus: string | null | undefined,
  schemeId: string | number | undefined | null
) => {
  return isIndividualResidentApplicant(applicantStatus) && isSchemeId3(schemeId);
};

// Combined check: applicant is a Resident Individual (RI) AND the scheme is an outbound fund.
// Used to lock Nationality to India for Resident Individuals on outbound funds.
export const isRiOutboundFund = (
  applicantStatus: string | null | undefined,
  schemeId: string | number | undefined | null
) => {
  return isIndividualResidentApplicant(applicantStatus) && isOutboundFund(schemeId);
};
